export default __webpack_public_path__ + "static/media/tidy3d_banner_bg.a9a3b1a4.png";